import type { SVGProps } from "react";

export function IconPurpleThunder(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#FBF6FE" />
      <path
        d="M16 30.5L29 14.5V25.5H40L27 41.5V30.5H16Z"
        fill="#2E2E2E"
        stroke="#2E2E2E"
        strokeWidth="1.5"
      />
    </svg>
  );
}
